(() => {
  const root = document.getElementById('AhvellaChatbot');
  if (!root) return;

  const launcher = root.querySelector('.ahvella-chatbot__launcher');
  const panel = root.querySelector('.ahvella-chatbot__panel');
  const close = root.querySelector('.ahvella-chatbot__close');
  const form = root.querySelector('[data-chat-form]');
  const input = root.querySelector('#AhvellaChatInput');
  const messages = root.querySelector('[data-chat-messages]');
  const status = root.querySelector('[data-chat-status]');
  const reset = root.querySelector('[data-chat-reset]');
  const welcome = root.querySelector('[data-welcome]');
  const prompts = root.querySelector('[data-quick-prompts]');
  const sendButton = form.querySelector('button[type="submit"]');
  let lastTrigger = launcher;
  let history = [];
  let sending = false;

  const setOpen = (open) => {
    root.dataset.open = String(open);
    launcher.setAttribute('aria-expanded', String(open));
    panel.setAttribute('aria-hidden', String(!open));
    if (open) {
      lastTrigger = document.activeElement || launcher;
      window.requestAnimationFrame(() => input.focus());
    } else if (lastTrigger?.focus) lastTrigger.focus();
  };

  const resetChat = () => {
    messages.querySelectorAll('.ahvella-chatbot__message:not([data-welcome]), .ahvella-chatbot__quick-prompts:not([data-quick-prompts])').forEach((node) => node.remove());
    if (!messages.contains(welcome)) messages.prepend(welcome);
    if (!messages.contains(prompts)) messages.append(prompts);
    history = [];
    setStatus(root.dataset.endpoint.trim() ? '' : 'Support fallback active.');
  };

  const addMessage = (text, kind) => {
    const bubble = document.createElement('div');
    bubble.className = `ahvella-chatbot__message ahvella-chatbot__message--${kind}`;
    bubble.textContent = text;
    messages.appendChild(bubble);
    messages.scrollTop = messages.scrollHeight;
    return bubble;
  };

  const setStatus = (text) => { status.textContent = text; };

  const remember = (role, content) => {
    history = [...history, { role, content }].slice(-6);
  };

  const getProductHandle = () => {
    const match = window.location.pathname.match(/^\/products\/([a-z0-9-]+)/i);
    return match ? match[1].toLowerCase() : '';
  };

  const sendMessage = async (text) => {
    if (sending) return;
    sending = true;
    const endpoint = root.dataset.endpoint.trim();
    const recentHistory = history.slice(-6);
    addMessage(text, 'user');
    remember('user', text);
    input.disabled = true;
    if (sendButton) sendButton.disabled = true;
    root.querySelector('[data-quick-prompts]')?.remove();
    if (!endpoint) {
      addMessage('Live assistant answers are not configured yet. Please use Contact for help and we will route your question safely.', 'error');
      setStatus('Support fallback active.');
      sending = false;
      input.disabled = false;
      if (sendButton) sendButton.disabled = false;
      return;
    }
    const typing = addMessage('Thinking…', 'assistant');
    typing.setAttribute('aria-busy', 'true');
    setStatus('Assistant is typing…');
    try {
      const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ message: text, history: recentHistory, productHandle: getProductHandle(), pagePath: window.location.pathname }) });
      if (!response.ok) throw new Error(`Provider returned ${response.status}`);
      const data = await response.json();
      typing.remove();
      const answer = typeof data.answer === 'string' ? data.answer : data.reply;
      const assistantMessage = typeof answer === 'string' && answer.trim() ? answer : 'The assistant did not return a message. Please use Contact for help.';
      addMessage(assistantMessage, 'assistant');
      remember('assistant', assistantMessage);
      setStatus('');
    } catch (error) {
      typing.remove();
      const errorBubble = addMessage('We could not connect right now. Please try again or use Contact for help.', 'error');
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = 'Retry'; retry.className = 'button button--secondary'; retry.addEventListener('click', () => { errorBubble.remove(); sendMessage(text); });
      errorBubble.append(' ', retry);
      setStatus('Connection error.');
    } finally {
      sending = false;
      input.disabled = false;
      if (sendButton) sendButton.disabled = false;
    }
  };

  launcher.addEventListener('click', () => setOpen(root.dataset.open !== 'true'));
  close.addEventListener('click', () => setOpen(false));
  reset?.addEventListener('click', resetChat);
  form.addEventListener('submit', (event) => { event.preventDefault(); const text = input.value.trim(); if (!text) return; input.value = ''; sendMessage(text); });
  root.querySelectorAll('[data-prompt]').forEach((button) => button.addEventListener('click', () => sendMessage(button.dataset.prompt)));
  panel.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || root.dataset.open !== 'true') return;
    const focusable = [...panel.querySelectorAll('button, input, textarea, select, a[href], [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && root.dataset.open === 'true') setOpen(false); });
})();
